import { Col, Navbar } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import {
	Header as LithoHeader,
	HeaderNav,
	Menu,
} from '../../Litho/Components/Header/Header';
import Buttons from '../../Litho/Components/Button/Buttons';
import colors from '../../constants/colors';
import useResponsiveScreen from '../../hooks/useResponsiveScreen';

const Header = ({ props }) => {
	const { isMobile } = useResponsiveScreen();
	return (
		<LithoHeader
			topSpace={{ desktop: false, md: true }}
			className='one-page-navigation'
			bg='white'
		>
			<HeaderNav fluid='lg' containerClass='sm:px-0' className='py-[0px]'>
				<Col className='col-auto col-sm-6 col-lg-2 me-auto ps-lg-0'>
					<Link
						aria-label='header logo'
						className='flex items-center my-[20px] md:my-[18px] mx-0 ml-[10px]'
						to='/'
					>
						<Navbar.Brand className='inline-block p-0 m-0'>
							<img
								className='default-logo !w-[150px]'
								loading='lazy'
								src='/assets/img/inter-logo.png'
								alt='logo'
							/>
							<img
								className='mobile-logo !w-[120px] notMobile:hidden'
								height='36'
								loading='lazy'
								src='/assets/img/inter-logo.png'
								alt='logo'
							/>
						</Navbar.Brand>
					</Link>
				</Col>
				<Col lg={{ order: 2 }} xs={{ order: 3 }} className='md:contents'>
					<Navbar.Toggle className='order-last md:ml-[17px] sm:ml-0 md:px-[25px] md:mr-4'>
						<span className='navbar-toggler-line'></span>
						<span className='navbar-toggler-line'></span>
						<span className='navbar-toggler-line'></span>
						<span className='navbar-toggler-line'></span>
					</Navbar.Toggle>
					<Navbar.Collapse className='col-auto col-lg-7 px-lg-0 mx-auto justify-center bg-white z-10'>
						<Menu
							data={[
								{ title: 'Home', link: '/' },
								{
									title: 'Services',
									link: '/air-freight',
									dropdown: [
										{
											title: 'Air Freight',
											link: '/air-freight',
										},
										{
											title: 'Road Freight',
											link: '/road-freight',
										},
										{
											title: 'Ocean Freight',
											link: '/ocean-freight',
										},
									],
								},
								{
									title: 'About Us',
									link: '/about',
								},
								{ title: 'Contact Us', link: '/contact' },
								isMobile
									? {
											title: (
												<Buttons
													ariaLabel='tab button'
													className='rounded-full bg-tprimary text-white font-medium font-serif hover:!text-white tracking-[1px] uppercase'
													size='md'
													themeColor={colors.tprimary}
													to='/track'
													title='Track Shipment'
												/>
											),
											link: '/contact',
									  }
									: null,
							].filter(Boolean)}
							{...props}
						/>
					</Navbar.Collapse>
				</Col>
				{!isMobile && (
					<Col
						lg={{ order: 3 }}
						xs={{ order: 2 }}
						className='col-auto col-lg-2 text-end pe-0 font-size-0'
					>
						<Buttons
							ariaLabel='tab button'
							className='rounded-full bg-tprimary text-white font-medium font-serif  hover:!bg-red-700 hover:shadow-lg tracking-[1px] uppercase hidden notMobile:inline-block'
							size='md'
							themeColor={colors.tprimary}
							to='/track-shipment'
							title='Track Shipment'
						/>
					</Col>
				)}
			</HeaderNav>
		</LithoHeader>
	);
};

export default Header;
